// extracted by mini-css-extract-plugin
export default {"Section":"Disclosure_Section__b3Pq-","Header":"Disclosure_Header__3nsDx"};